import React, {PureComponent, ComponentClass, CSSProperties} from 'react'
import cxs from 'cxs/component'
import Theme, {easing} from 'Theme'

interface Props {}

export default class Loading extends PureComponent<Props, object> {
  render() {
    return <Spinner {...this.props} />
  }
}

const SpinnerStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  // display: 'inline-block',
  width: '30px',
  height: '30px',
  marginTop: '-15px',
  marginLeft: '-15px',
  borderRadius: '50%',
  border: `2px solid ${Theme.color.hairline}`,
  borderTopColor: Theme.color.primary,
  animation: `spinner .7s ease-in-out infinite`
  // backgroundColor: 'white',
  // boxShadow: '0 0 10px white'
} as CSSProperties

const Spinner = cxs('div')(SpinnerStyle)

export const spinner = {
  ':before': {
    ...SpinnerStyle,
    content: '""'
  }
}

// tslint:disable:no-any

interface State {
  values?: any[]
}

export const loading = <P extends {}>(promises: (props: P) => any[]) => (
  DecoratedComponent: ComponentClass<any>
): any =>
  class extends PureComponent<P, State> {
    state: State = {
      values: undefined
    }

    componentWillMount() {
      Promise.all(promises(this.props as P)).then(results => {
        this.setState({
          values: results.reduce((values, value) => {
            if (typeof value === 'object') Object.assign(values, value)
            return values
          }, {})
        })
      })
    }

    render() {
      const {values} = this.state
      if (values) return <DecoratedComponent {...this.props} {...values} />
      return <Loading />
    }
  }



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/elements/Loading.tsx